import { createPromise } from "./create";
/**
 * ```
 * const waiter = new Waiter();
 * waiter.trigger();
 * await waiter.wait();
 * ```
 */
export class Waiter {
    constructor() {
        this.triggered = false;
        this.resolvs = [];
    }
    async wait() {
        if (this.triggered) {
            return;
        }
        const { promise, resolve } = await createPromise();
        if (this.triggered) {
            return;
        }
        this.resolvs.push(resolve);
        await promise;
    }
    /**
     * wait promise가 resolve되게 만듬
     */
    trigger() {
        this.triggered = true;
        for (const resolve of this.resolvs) {
            setTimeout(resolve, 0);
        }
        this.resolvs = [];
    }
    reset() {
        this.triggered = false;
    }
    clear() {
        this.resolvs = [];
    }
}
export class WaiterWith {
    constructor() {
        this.triggered = null;
        this.resolvs = [];
    }
    async wait() {
        if (this.triggered) {
            return this.triggered;
        }
        const { promise, resolve } = await createPromise();
        if (this.triggered) {
            return this.triggered;
        }
        this.resolvs.push(resolve);
        await promise;
        return this.triggered;
    }
    /**
     * wait promise가 resolve되게 만듬
     */
    trigger(value) {
        this.triggered = value;
        for (const resolve of this.resolvs) {
            resolve();
        }
        this.resolvs = [];
    }
    reset() {
        this.triggered = null;
    }
}
//# sourceMappingURL=waiter.js.map